
import { defineComponent, computed, ref } from "vue";

import Form from "@/components/FormComp.vue";
import Task from "@/components/TaskComp.vue";
import Box from "@/components/BoxComp.vue";

import { useStore } from "@/store";
import useNotify from "@/hooks/notifier";

import ITask from "@/interfaces/ITask";
import { NotificationType } from "@/interfaces/INotication";
import {
  GET_PROJECTS,
  GET_TASKS,
  POST_TASK,
  PUT_TASK,
} from "@/store/actions-types";

export default defineComponent({
  name: "TasksView",
  setup() {
    const store = useStore();
    const { notify } = useNotify();

    store.dispatch(GET_TASKS);
    store.dispatch(GET_PROJECTS);

    const filter = ref("");
    const isDarkTheme = ref(false);
    const selectedTask = ref(null as ITask | null);
    const tasks = computed(() =>
      store.state.task.tasks.filter(
        (t) => !filter.value || t.description.includes(filter.value)
      )
    );

    const listIsEmpty = computed(() => {
      return {
        tasksIsEmpty: store.state.task.tasks.length === 0,
        filterIsEmpty: store.state.task.tasks.length && tasks.value.length == 0,
      };
    });

    const taskSelect = (task: ITask) => {
      selectedTask.value = task;
    };

    const modalClose = () => {
      selectedTask.value = null;
    };

    const addTask = (task: ITask) => {
      const project = store.state.project.projects.find(
        (p) => p.id == task.project.id
      );
      if (!project) {
        notify(
          "Ops!",
          "Selecione um projeto antes de finalizar a tarefa!",
          NotificationType.FAIL
        );
        return;
      }
      store.dispatch(POST_TASK, task);
    };

    const editTask = () => {
      store.dispatch(PUT_TASK, selectedTask.value).then(() => modalClose());
    };

    const toggleTheme = (isDarkThemeP: boolean) => {
      isDarkTheme.value = isDarkThemeP;
    };

    return {
      isDarkTheme,
      selectedTask,
      tasks,
      filter,

      listIsEmpty,
      taskSelect,
      modalClose,
      addTask,
      editTask,
      toggleTheme,
    };
  },
  components: {
    Form,
    Task,
    Box,
  },
});
